// https://github.com/ricokahler/color2k/blob/main/src/ColorError.ts

class ColorError extends Error {
  constructor(color) {
    super(`Failed to parse color: "${color}"`);
  }
}
export default ColorError;